import dayjs from 'dayjs';
import { t } from 'i18next';
import { StudentMapping, studentMappingOptions, XlsxImportEntry } from '../types/XlsxImportTypes';

export const getStringFromEntry = (entry: unknown): string => {
  if (entry instanceof Date) {
    return dayjs(entry).format('DD.MM.YYYY');
  } else if (entry === null || entry === undefined) {
    return '';
  } else {
    return String(entry);
  }
};

export const getLabelFromMapping = <T extends StudentMapping>(option: T): string => {
  // Check if the option is a valid StudentMapping value
  if ((studentMappingOptions as readonly string[]).includes(option)) {
    return getStudentMappingLabel(option);
  }
  return '';
};

const getStudentMappingLabel = (option: StudentMapping): string => {
  switch (option) {
    case 'salutation':
      return t('persons.salutation');
    case 'title':
      return t('persons.personTitle');
    case 'lastName':
      return t('common.lastName');
    case 'firstName':
      return t('common.firstName');
    case 'firstNames':
      return t('common.firstNames');
    case 'prefixName':
      return t('common.prefixName');
    case 'shortName':
      return t('common.shortName');
    case 'email':
      return t('common.email');
    case 'birthday':
      return t('common.birthday');
    case 'address1':
      return t('common.address');
    // case 'organizationRoles':
    //   return t('profiles.role');
    case 'foreignRefId':
      return t('import.foreignRefId');
    case 'grade':
      return t('classes.grade');
    case 'gradeGroup':
      return t('classes.gradeGroup');
    case 'gradeAndGradeGroup':
      return t('classes.gradeAndGradeGroup');
    default:
      return option;
  }
};

export const studentSortFn = (a: XlsxImportEntry<StudentMapping>, b: XlsxImportEntry<StudentMapping>) => {
  // sort grade then by lastname, then firstname
  if (a.grade && b.grade) {
    const gradeComparison = a.grade.toString().localeCompare(b.grade.toString(), undefined, { numeric: true });
    if (gradeComparison !== 0) return gradeComparison;
  } else if (a.grade) {
    return -1;
  } else if (b.grade) {
    return 1;
  }

  if (a.lastName && b.lastName) {
    const lastNameComparison = a.lastName.localeCompare(b.lastName);
    if (lastNameComparison !== 0) return lastNameComparison;
  } else if (a.lastName) {
    return -1;
  } else if (b.lastName) {
    return 1;
  }

  if (a.firstName && b.firstName) {
    return a.firstName.localeCompare(b.firstName);
  } else if (a.firstName) {
    return -1;
  } else if (b.firstName) {
    return 1;
  }

  return 0;
};
